/**
 * Demo stubs for leaveRequestsApi methods.
 * Returns safe empty/success responses to prevent crashes in demo mode.
 */
export const demoLeaveRequestsService = {
  getLeaveTypes: async () => [],
  getMyBalance: async () => [],
  getEmployeeBalance: async () => [],
  submitRequest: async () => ({ id: 1, days: 0, status: 'pending' }),
  getMyRequests: async () => [],
};
